












import Vue from 'vue';

export default Vue.extend({
  name: 'TextoComLink',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  methods: {
    isUrl(word: string) {
      return word.includes('http://') || word.includes('https://');
    },
  },
});
